<template>
  <el-form ref="serveForm" :model="serveForm" :rules="serveRules" label-width="110px">
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item label="设备型号" prop="deviceModel">
          <el-input
            v-if="!isDetail()"
            v-model="serveForm.deviceModel"
            maxlength="50"
            placeholder="请输入"
          ></el-input>
          <span v-else>{{ serveForm.deviceModel || '-' }}</span>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="出厂编号" prop="factoryNo">
          <el-input
            v-if="!isDetail()"
            v-model="serveForm.factoryNo"
            maxlength="50"
            placeholder="请输入"
          ></el-input>
          <span v-else>{{ serveForm.factoryNo || '-' }}</span>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item label="设备状态" prop="status">
          <el-select v-if="!isDetail()" v-model="serveForm.status" style="width: 100%">
            <el-option
              v-for="item in typeList"
              :key="item.type"
              :label="item.typeName"
              :value="item.type"
            ></el-option>
          </el-select>
          <span v-else>{{ typeObj[serveForm.status] }}</span>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item label="cpu" prop="cpu">
          <el-input
            v-if="!isDetail()"
            v-model="serveForm.cpu"
            maxlength="50"
            placeholder="请输入"
          ></el-input>
          <span v-else>{{ serveForm.cpu || '-' }}</span>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="内存" prop="ram">
          <el-input
            v-if="!isDetail()"
            v-model="serveForm.ram"
            maxlength="50"
            placeholder="请输入"
          ></el-input>
          <span v-else>{{ serveForm.ram || '-' }}</span>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item label="磁盘" prop="hardDisk">
          <el-input
            v-if="!isDetail()"
            v-model="serveForm.hardDisk"
            maxlength="50"
            placeholder="请输入"
          ></el-input>
          <span v-else>{{ serveForm.hardDisk || '-' }}</span>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="带宽" prop="bandwidth">
          <el-input
            v-if="!isDetail()"
            v-model="serveForm.bandwidth"
            maxlength="50"
            placeholder="请输入"
          ></el-input>
          <span v-else>{{ serveForm.bandwidth || '-' }}</span>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item label="操作系统" prop="os">
          <el-cascader
            v-if="!isDetail()"
            style="width: 100%"
            :show-all-levels="false"
            :options="osOptions"
            v-model="serveForm.os"
            maxlength="50"
            placeholder="请输入"
            clearable
          ></el-cascader>
          <span v-else>{{ (serveForm.os && serveForm.os.join('-')) || '-' }}</span>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item label="局域网IP" prop="lanIp">
          <el-input
            v-if="!isDetail()"
            v-model="serveForm.lanIp"
            maxlength="50"
            placeholder="请输入"
          ></el-input>
          <span v-else>{{ serveForm.lanIp || '-' }}</span>
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
</template>
<script>
export default {
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: {
      type: Object
    }
  },
  data() {
    return {
      osObj: {
        CentOs: 'Linux',
        Fedora: 'Linux',
        Redhat: 'Linux',
        Debian: 'Linux',
        Ubuntu: 'Linux',
        Gentoo: 'Linux',
        FreeBSD: 'Linux',
        OpenSUSE: 'Linux'
      },
      osOptions: [
        {
          value: 'Windows',
          label: 'Windows'
        },
        {
          value: 'Unix',
          label: 'Unix'
        },
        {
          value: 'Linux',
          label: 'Linux',
          children: [
            {
              value: 'CentOs',
              label: 'CentOs'
            },
            {
              value: 'Fedora',
              label: 'Fedora'
            },
            {
              value: 'Redhat',
              label: 'Redhat'
            },
            {
              value: 'Debian',
              label: 'Debian'
            },
            {
              value: 'Ubuntu',
              label: 'Ubuntu'
            },
            {
              value: 'Gentoo',
              label: 'Gentoo'
            },
            {
              value: 'FreeBSD',
              label: 'FreeBSD'
            },
            {
              value: 'OpenSUSE',
              label: 'OpenSUSE'
            }
          ]
        },
        {
          value: 'MacOs',
          label: 'MacOs'
        }
      ],
      typeList: [
        { type: 0, typeName: '启用' },
        { type: 1, typeName: '停用' }
      ],
      typeObj: {
        0: '启用',
        1: '停用'
      },
      serveForm: {}
    };
  },
  inject: ['isDetail'],
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler: function (newVal) {
        this.serveForm = newVal;
      }
    },
    serveForm: {
      immediate: true,
      deep: true,
      handler: function (newVal) {
        this.$emit('change', newVal);
      }
    }
  },
  computed: {
    serveRules() {
      return {
        status: [{ required: !this.isDetail(), message: '请选择设备状态', trigger: 'change' }],
        lanIp: [{ required: !this.isDetail(), message: '请输入IP', trigger: 'blur' }]
      };
    }
  },
  methods: {
    getNationNo() {
      // getNationNum().then(res => {
      //   if (!res.success) {
      //     return;
      //   }
      //   this.serveForm.mnNum = res.data
      // });
    },
    getData() {
      let data = {
        deviceModel: this.serveForm.deviceModel,
        factoryNo: this.serveForm.factoryNo,
        status: this.serveForm.status,
        cpu: this.serveForm.cpu,
        memory: this.serveForm.ram,
        disk: this.serveForm.hardDisk,
        bandwidth: this.serveForm.bandwidth,
        os: this.serveForm.os.join(','),
        localAreaIp: this.serveForm.lanIp
      };
      return data;
    },
    setData(data) {
      const { deviceModel, factoryNo, status, cpu, memory, disk, bandwidth, os, localAreaIp } =
        data;
      this.serveForm.deviceModel = deviceModel;
      this.serveForm.factoryNo = factoryNo;
      this.serveForm.status = status;
      this.serveForm.cpu = cpu;
      this.serveForm.ram = memory;
      this.serveForm.hardDisk = disk;
      this.serveForm.bandwidth = bandwidth;
      this.serveForm.os = os.split(',');
      this.serveForm.lanIp = localAreaIp;
    },
    reset() {
      this.$refs.serveForm.resetFields();
    },
    validate() {
      let type;
      this.$refs.serveForm.validate(validated => {
        type = validated;
      });
      return type;
    }
  }
};
</script>
